export const charFromInteger = (integer: number) => {
  const baseCharCode = 'A'.charCodeAt(0);
  return String.fromCharCode(baseCharCode + ((integer - 1) % 26));
};

export const numericInputStringToNumber = (input: string): number | null => {
  return input.trim() !== '' ? Number(input.trim()) : null;
};

const currencyFormatCache: {
  [cacheKey: string]: Intl.NumberFormat | null;
} = {};

// Creating Intl.NumberFormat is an expensive operation, so we want to cache and reuse instances
const getCurrencyFormat = (options: { showPoundSymbol: boolean; decimalPlaces: number }) => {
  const cacheKey = `showPoundSymbol:${options.showPoundSymbol}-decimals:${options.decimalPlaces}`;
  return (
    currencyFormatCache[cacheKey] ||
    (currencyFormatCache[cacheKey] = new Intl.NumberFormat(undefined, {
      style: options.showPoundSymbol ? 'currency' : 'decimal',
      currency: options.showPoundSymbol ? 'GBP' : undefined,
      maximumFractionDigits: options.decimalPlaces,
      minimumFractionDigits: options.decimalPlaces,
    }))
  );
};

export const formatCurrency = (
  value: number,
  { showPoundSymbol, decimalPlaces }: { showPoundSymbol?: boolean; decimalPlaces?: number } = {},
) => {
  const numberFormat = getCurrencyFormat({
    showPoundSymbol: showPoundSymbol != null ? showPoundSymbol : false,
    decimalPlaces: decimalPlaces != null ? decimalPlaces : 2,
  });
  return numberFormat.format(value);
};

export const parseNumberOrNull = (value: string): number | null =>
  value.trim() === '' || isNaN(Number(value)) ? null : Number(value);
